import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Tag, Save, ExternalLink } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const Row = ({ r, i, onSaved }) => {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await http.put(`/kits/${r.kit_id}/price-fill/row`, { si: r.si, ei: r.ei, ci: r.ci, venue: r.venue, item: r.item, amount: v }); toast.success(`Saved ${r.venue} — ${v}`); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <li data-testid={`unverified-row-${i}`} className="flex flex-wrap items-center gap-2 border-t border-stone-100 py-1.5 text-sm">
      <Link data-testid={`unverified-kit-link-${i}`} to={`/kits/${r.kit_id}`} className="inline-flex items-center gap-1 text-xs text-[#9A7B2C] hover:underline">
        {r.destination?.split(",")[0]} · {r.tier} <ExternalLink size={11} />
      </Link>
      <b className="text-[#2B2A26]">{r.venue}</b>
      <span className="min-w-0 flex-1 truncate text-stone-600">{r.item}</span>
      <input data-testid={`unverified-amount-${i}`} value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => e.key === "Enter" && v.trim() && save()}
        placeholder="e.g. $45" className="w-28 rounded-sm border border-stone-300 px-2 py-1 text-xs focus:border-[#C9A847] focus:outline-none" />
      <button data-testid={`unverified-save-${i}`} disabled={busy || !v.trim()} onClick={save}
        className="inline-flex items-center gap-1 rounded-sm bg-[#2B2A26] px-2.5 py-1 text-xs font-bold text-white hover:bg-black disabled:opacity-40"><Save size={11} /> Save</button>
    </li>
  );
};

export const UnverifiedPrices = () => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => http.get("/price-fill/unverified").then((x) => setRows(x.data.rows)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!rows?.length) return null;
  return (
    <section data-testid="unverified-prices-panel" className="mb-6 rounded-lg border border-amber-200 bg-white p-4">
      <div className="flex items-center gap-2">
        <Tag size={16} className="text-amber-600" />
        <b className="text-[#2B2A26]">Prices not verified</b>
        <span data-testid="unverified-prices-count" className="text-sm text-stone-500">{rows.length} row(s) the web couldn't confirm — type the price or open the kit</span>
      </div>
      <ul className="mt-2 max-h-80 overflow-y-auto">
        {rows.map((r, i) => <Row key={`${r.kit_id}-${r.si}-${r.ei}-${r.ci}`} r={r} i={i} onSaved={load} />)}
      </ul>
    </section>
  );
};
